import React from 'react';
import { MdOutlineMail } from "react-icons/md";
import { BsTelephone } from "react-icons/bs";
import campusLogo from '../../../assets/images/campus-logo-white.png';
const Footer = () => {
  return (
    <footer className="bg-site text-gray-800 py-36 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-wrap justify-between items-start gap-10">
         
          {/* Left Section: Logo and Copyright */}
          <div className="flex flex-col h-full">
            <div className="flex items-center gap-3">
              {/* Campus Crow Logo */}
           
              <div>
                <img src={campusLogo} alt="Campus Crow Logo" />
              </div>
            </div>
            <p className="text-white-500 text-sm  mt-3 transition-colors text-[#f4f4f4]">© Campus Crow LLC</p>
          </div>
          {/* Right Section: Links */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-12 gap-y-8">
            {/* Policies Column */}
            <div>
              <h4 className="font-semibold text-lg text-[#f4f4f4]">Policies</h4>
              <ul className="mt-4 space-y-3">
                <li><a href="#" className="text-[#f4f4f4] transition-colors hover:text-[rgb(183,51,130)]">Privacy and Policy</a></li>
                <li><a href="#" className="text-[#f4f4f4] transition-colors hover:text-[rgb(183,51,130)]">Terms of Service</a></li>
              </ul>
            </div>
            {/* Contact Us Column */}
            <div>
              <h4 className="font-semibold text-lg text-[#f4f4f4]">Contact Us</h4>
              <ul className="mt-4 space-y-3">
                <li className="flex items-center">
                  <MdOutlineMail className="mr-2 text-[#f4f4f4]" />
                  <a href="mailto:info@campuscrow.com" className="text-[#f4f4f4] transition-colors hover:text-[rgb(183,51,130)]">info@campuscrow.com</a>
                </li>
                <li className="flex items-center">
                  <BsTelephone className="mr-2 text-[#f4f4f4]" />
                  <a href="tel:+16627154678" className="text-[#f4f4f4] transition-colors hover:text-[rgb(183,51,130)]">+1 (662) 715-4678</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;